<template>
  <div>
    <p class="cm-mg-p-wzd">
      4.1 {{ $t('devices.station_association_nearby_stations') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-4">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('devices.station_select') }}:</label
          >
          <br />
          <el-select
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.station_access_id"
            :placeholder="`${$t('common_words.select')}...`"
            @change="
              model.sensor_access_id = [];
              model.calculated_sensor_access_id = [];
            "
          >
            <el-option
              v-for="option in stations"
              class="select-primary"
              :value="option.id"
              :label="`${option.name}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-4" v-if="model.station_access_id">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{
              `${$t('common_words.select_one_or_many')} ${$t(
                'devices.sensors'
              ).toLowerCase()}`
            }}:</label
          >
          <br />
          <!-- [this.parent_self.model.station_access_id] -->
          <el-select
            collapse-tags
            @change="
              selectAllFromSelect('model.sensor_access_id', getSensorsList)
            "
            clearable
            multiple
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.sensor_access_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <!-- [model.station_access_id] -->
            <el-option
              v-for="option in getSensorsList"
              class="select-primary selected-all"
              :value="option.id"
              :label="`${option.name}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-4" v-if="model.station_access_id">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{
              `${$t('common_words.select_one_or_many')} ${$t(
                'devices.calculations'
              ).toLowerCase()}`
            }}:</label
          >
          <br />
          <el-select
            collapse-tags
            @change="
              selectAllFromSelect(
                'model.calculated_sensor_access_id',
                getCalculatedSensors
              )
            "
            clearable
            multiple
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.calculated_sensor_access_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in getCalculatedSensors"
              class="select-primary selected-all"
              :value="option.id"
              :label="`${option.name}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinAlert from 'src/mixins/mixin-alert';
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';

export default {
  data() {
    return {
      model: {
        station_access_id: null,
        sensor_access_id: [],
        calculated_sensor_access_id: [],
      },
      stations: [],
      sensors: [],
    };
  },
  mixins: [MixinPermissions, mixinMasters, MixinAlert],
  watch: {
    '$i18n.locale': 'getSelectAll',
  },
  computed: {
    getSensorsByStation() {
      const result = this.sensors.filter(
        (sensor) =>
          Number(sensor.id) != 0 &&
          sensor.stations.includes(this.model.station_access_id)
      );

      return this.concatAll(result);
    },
    getSensorsList() {
      const result = this.getSensorsByStation.filter(
        (sensor) => Number(sensor.calculated) === 0
      );

      return this.concatAll(result);
    },
    getCalculatedSensors() {
      const result = this.getSensorsByStation.filter(
        (sensor) => Number(sensor.calculated) === 1
      );

      return this.concatAll(result);
    },
  },
  methods: {
    getSelectAll() {
      this.sensors = this.concatAll(this.sensors.splice(1));
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);
        this.$emit('fillStationForm', 'fourthStep', {
          sensor_access_id: this.model.sensor_access_id.concat(
            this.model.calculated_sensor_access_id
          ),
          station_access: isset(this.model.station_access_id)
            ? this.stations.find(
                (station) => station.id === this.model.station_access_id
              ).name
            : null,
          sensors_access: isset(this.model.sensor_access_id)
            ? this.model.sensor_access_id.map((sensorId) => {
                const result = this.sensors.find((sensor) => {
                  return sensor.id === sensorId;
                });

                return { name: result.name };
              })
            : null,
          calculated_sensors_access: isset(
            this.model.calculated_sensor_access_id
          )
            ? this.model.calculated_sensor_access_id.map((sensorId) => {
                const result = this.sensors.find((sensor) => {
                  return sensor.id === sensorId;
                });

                return { name: result.name };
              })
            : null,
        });
        return res;
      });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('devices/stations/only/all'),
        Axios.getMasters('devices/sensors/toSelect/all'),
      ])
        .then((response) => {
          const [responseStation, responseSensors] = response;

          this.stations = responseStation.data.data;
          this.sensors = this.concatAll(
            responseSensors.data.data.map((sensor) => {
              const { id, name, code, stations, calculated } = sensor;
              return {
                id: id,
                name: `${code} - ${name}`,
                calculated,
                stations: stations,
              };
            })
          );

          if (sessionStorage.getItem('editForm')) {
            const { id, stations_access, sensors_access } = JSON.parse(
              sessionStorage.getItem('editForm')
            );
            this.stations = this.stations.filter(
              (station) => station.id !== id
            );
            this.model.station_access_id =
              stations_access[0].pivot.station_access_id;
            const sensorsId = sensors_access
              .filter(({ calculated }) => Number(calculated) === 0)
              .map(({ pivot: { sensor_access_id } }) => sensor_access_id);
            const calculatedSensorsId = sensors_access
              .filter(({ calculated }) => Number(calculated) === 1)
              .map(({ pivot: { sensor_access_id } }) => sensor_access_id);

            this.model.sensor_access_id = sensorsId;
            this.model.calculated_sensor_access_id = calculatedSensorsId;
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else this.showHideLoading();
  },
};
</script>
<style></style>
